<div
  #modal
  class="modal fade"
  id="{{ modalId }}"
  data-bs-backdrop="static"
  tabindex="-1"
  [attr.aria-labelledby]="modalId + '-label'"
  aria-hidden="true"
  style="background-color: rgba(197, 206, 224, 0.7)"
>
  <div
    class="modal-dialog modal-{{ size }}"
    [class.modal-dialog-centered]="isCentered"
    [class.modal-dialog-scrollable]="isScrollable"
  >
    <div class="modal-content border-0">
      <div class="modal-header border-0 align-items-start">
        <h5 class="mb-0" id="{{ modalId }}-label">
          {{ title }}
        </h5>
        <button
          type="button"
          class="btn-close ms-md-5"
          data-bs-dismiss="modal"
          aria-label="Close"
          (click)="close()"
        ></button>
      </div>
      <div class="modal-body py-0">
        <ng-content select="[modal-body]"></ng-content>
      </div>

      <ng-content select="[modal-footer]"></ng-content>
    </div>
  </div>
</div>
